export const CustomerConfig = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};
